import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'

export default function Badge({ color, size, customCss, text, icon }) {
  if (icon) {
    return (
      <div
        className={`${styles.container} ${styles.icon} ${customCss} ${color && styles[color]} ${size && styles[size]}`}>
        <Icon name={icon} size='large24' /> {text}
      </div>
    )
  }
  return (
    <div className={`${styles.container} ${customCss} ${color && styles[color]}  ${size && styles[size]}`}>{text}</div>
  )
}

Badge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  customCss: PropTypes.string,
  text: PropTypes.number.isRequired,
  icon: PropTypes.string
}

Badge.defaultProps = {
  color: 'green' /** red/green/orange/gray */,
  size: 'small' /**small/medium/large */,
  customCss: '',
  icon: ''
}
